const state = {
  datos: []
}

export default state
